import React from 'react';
import { Phone } from 'lucide-react';

export default function FloatingScheduleButton() {
  const handleBookAppointment = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.preventDefault();
  /* window.open('https://docs.google.com/forms/d/1oRkezXBplNPdIYwIX0IXZ5tUfwCoB_PTaPpuL2OfoVk', '_blank');
  */
 window.open('https://healow.com/apps/practice/frederick-metabolic-and-primary-care-associates-llc-30589?v=2&t=1' , '_blank'); 
};

  return (
    <div className="fixed right-4 bottom-4 md:top-1/2 md:-translate-y-1/2 z-50 flex flex-col gap-4">
      {/* Phone Button - Mobile Optimized */}
      <a
        href="tel:240-949-7519"
        className="flex items-center justify-center bg-blue-700 text-white p-4 rounded-full md:rounded-l-lg shadow-lg hover:bg-blue-800 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2"
        aria-label="Call us at 240-949-7519"
      >
        <Phone className="h-6 w-6 md:mr-2" aria-hidden="true" />
        <span className="hidden md:inline">240-949-7519</span>
      </a>

      {/* Schedule Button */}
      <button
        onClick={handleBookAppointment}
        className="bg-blue-700 text-white p-4 md:px-6 md:py-4 rounded-full md:rounded-l-lg shadow-lg hover:bg-blue-800 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 group"
        aria-label="Schedule an appointment"
        role="button"
      >
        {/* Mobile View */}
        <span className="block md:hidden text-sm font-medium">
          Schedule
        </span>
        
        {/* Desktop View */}
        <span className="hidden md:block writing-mode-vertical text-lg font-medium">
          Schedule Appointment
        </span>
        <span className="sr-only">Opens appointment form in new tab</span>
      </button>
    </div>
  );
} 